import { TLegacyErrors } from '@alycecom/services';
import { createAsyncAction } from '@alycecom/utils';

import { ICodeRequestParams } from '../types/Request.types';

import { IUsersResponse } from './users.types';

export const fetchUsers = createAsyncAction<ICodeRequestParams, IUsersResponse, TLegacyErrors>('USERS');
